// The subscriber-facing name of the list, in one place so the branding can be
// changed without hunting through the page, the banner, the sidebar and the
// dashboard card. Title case: the surfaces that want it shouted apply
// textTransform themselves.
export const LIST_NAME = 'Carnivore 33'
